import React, { useEffect, useState } from 'react';

import { TitleSections } from '../../../components/TitleSections';
import { DadosParaLeitura } from './dadosParaLeitura';
import { DadosParaEdicao } from './dadosParaEdicao';
import { useAuth } from '../../../hooks/auth';

export function DadosDoMotorista({
  dadosMotorista = {},
  carregarSolicitacaoAtual,
  setSpinning,
  tipoValidacao,
}) {
  const [readOnly, setReadOnly] = useState(true);

  const [isAdministrador, setIsAdministrador] = useState(false);
  const { temPermissao } = useAuth();
  useEffect(() => {
    const isAdmin =
      temPermissao(['EditarCadastroPainel']) && tipoValidacao === 1;
    setIsAdministrador(isAdmin);
  }, [temPermissao, tipoValidacao]);

  return (
    <>
      <TitleSections
        title="Dados cadastrais do motorista"
        withButton={!!isAdministrador}
        buttonTitle="Editar"
        setReadOnly={setReadOnly}
        readOnly={readOnly}
      />
      {readOnly ? (
        <DadosParaLeitura dadosMotorista={dadosMotorista} />
      ) : (
        <DadosParaEdicao
          carregarSolicitacaoAtual={carregarSolicitacaoAtual}
          setReadOnly={setReadOnly}
          dadosMotorista={dadosMotorista}
          setSpinning={setSpinning}
        />
      )}
    </>
  );
}
